module.exports = __webpack_public_path__ + "static/media/0.fe2ad87e.jpg";